import { render, staticRenderFns } from "./booking_Goods_list_tab.vue?vue&type=template&id=0bd3e2b4"
import script from "./booking_Goods_list_tab.vue?vue&type=script&lang=js"
export * from "./booking_Goods_list_tab.vue?vue&type=script&lang=js"
import style0 from "./booking_Goods_list_tab.vue?vue&type=style&index=0&id=0bd3e2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports